(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Applies the steppers and the remove links to the cart as they're used, and
  // re-renders this section from the reply so every figure on the page — line
  // totals, the subtotal, the total, the header's cart count — comes from the
  // cart itself rather than being worked out twice.
  //
  // Everything here is an upgrade on markup that already works: the quantity
  // fields are `updates[]` inputs in a plain POST to /cart, and the remove
  // links are ordinary links to /cart/change. With the script absent the page
  // reloads the way it always did.
  //
  // One set of delegated listeners covers the whole page, so the markup this
  // swaps in needs nothing bound to it afterwards.
  (() => {
    // Long enough to collect a run of clicks on the same `+` into one request,
    // short enough that a single click still feels answered.
    const UPDATE_DELAY = 250;

    const TOTAL_PLACEHOLDER = '[[total]]';

    // Cart writes are serialised: two updates in flight at once can come back
    // out of order and leave the page showing a quantity the cart doesn't hold.
    let queue = Promise.resolve();

    // Line key -> pending timeout. Also read as "is the shopper still clicking",
    // which is what suppresses a re-render that's about to be superseded.
    const timers = new Map();

    function setCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = count;
      });
    }

    // Focus is recorded as a description rather than a reference: the element
    // holding it is gone once the markup is replaced.
    function focusDescriptor(section) {
      const active = document.activeElement;
      if (!active || !section.contains(active)) return null;

      // The note is free text, so what's in it has to travel with the focus.
      // A quantity change queued before the shopper started typing would
      // otherwise land mid-sentence and replace the field with the cart's copy.
      if (active.hasAttribute('data-cart-note')) {
        return {
          note: true,
          value: active.value,
          start: active.selectionStart,
          end: active.selectionEnd,
        };
      }

      const line = active.closest('[data-line-key]');
      if (!line) return null;

      let selector = null;
      if (active.dataset.step) {
        selector = `[data-step="${active.dataset.step}"]`;
      } else if (active.hasAttribute('data-quantity-input')) {
        selector = '[data-quantity-input]';
      } else if (active.hasAttribute('data-remove')) {
        selector = '[data-remove]';
      }

      return selector ? { key: line.dataset.lineKey, selector } : null;
    }

    function restoreFocus(section, descriptor) {
      if (!descriptor) return;

      if (descriptor.note) {
        const note = section.querySelector('[data-cart-note]');
        if (!note) return;

        note.value = descriptor.value;
        note.focus();
        note.setSelectionRange(descriptor.start, descriptor.end);
        return;
      }

      const line = section.querySelector(`[data-line-key="${descriptor.key}"]`);
      const target = line && line.querySelector(descriptor.selector);

      if (target && !target.disabled) {
        target.focus();
        return;
      }

      // The row is gone — removed, or emptied down to nothing. Focus lands on
      // the heading so a keyboard shopper isn't dropped back at the top of the
      // document with no idea what happened.
      const heading = section.querySelector('[data-cart-heading]');
      if (heading) heading.focus();
    }

    function render(section, html) {
      const root = section.querySelector('[data-cart-root]');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-root]');
      if (!root || !fresh) return;

      const descriptor = focusDescriptor(section);
      root.innerHTML = fresh.innerHTML;
      restoreFocus(section, descriptor);

      const announce = section.querySelector('[data-cart-announce]');
      const total = section.querySelector('[data-cart-total]');
      if (announce && total && section.dataset.updatedLabel) {
        announce.textContent = section.dataset.updatedLabel.replace(
          TOTAL_PLACEHOLDER,
          total.textContent.trim()
        );
      }
    }

    function showError(section, key, message) {
      const line = section.querySelector(`[data-line-key="${key}"]`);
      const target =
        (line && line.querySelector('[data-line-error]')) || section.querySelector('[data-cart-error]');

      if (target) target.textContent = message;

      // The visible message starts out empty, and an empty paragraph is hidden,
      // so the announcement has to come from the region that's always there.
      const announce = section.querySelector('[data-cart-announce]');
      if (announce) announce.textContent = message;
    }

    // Used when the cart refused an update: it's unchanged, so the page has to
    // be put back to what it actually holds before the reason is shown.
    async function refresh(section) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', section.dataset.sectionId);

      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;

      render(section, await response.text());
    }

    async function change(section, key, quantity) {
      const sectionId = section.dataset.sectionId;
      section.setAttribute('data-busy', '');

      try {
        // `id` is the line item key rather than a line number: keys survive
        // other lines being removed while this update is queued behind them.
        const response = await fetch(`${section.dataset.changeUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        });

        const result = await response.json();

        if (!response.ok) {
          // Shopify explains the refusal in `description` — most often that the
          // quantity asked for is more than the stock left.
          await refresh(section);
          showError(section, key, result.description || result.message || section.dataset.errorMessage);
          return;
        }

        setCartCount(result.item_count);

        // Another click is already waiting, and its reply will carry newer
        // markup than this one. Rendering both would bounce the number the
        // shopper is looking at back to where it just came from.
        if (timers.size > 0) return;

        const html = result.sections && result.sections[sectionId];
        if (html) render(section, html);
      } catch (error) {
        showError(section, key, section.dataset.errorMessage);
      } finally {
        section.removeAttribute('data-busy');
      }
    }

    // The note rides on /cart/update rather than /cart/change, which only takes
    // a line and a quantity. No re-render follows: nothing else on the page is
    // derived from the note, and replacing the markup under a shopper who just
    // finished typing would be the one visible thing it did.
    async function saveNote(section, note) {
      section.setAttribute('data-busy', '');

      try {
        const response = await fetch(`${section.dataset.updateUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ note }),
        });

        if (!response.ok) showError(section, null, section.dataset.errorMessage);
      } catch (error) {
        showError(section, null, section.dataset.errorMessage);
      } finally {
        section.removeAttribute('data-busy');
      }
    }

    function schedule(section, key, quantity) {
      window.clearTimeout(timers.get(key));

      timers.set(
        key,
        window.setTimeout(() => {
          timers.delete(key);
          queue = queue.then(() => change(section, key, quantity));
        }, UPDATE_DELAY)
      );
    }

    function quantityOf(field) {
      // `min` stops the spinner going below zero, but the field can still be
      // cleared or typed into, so the floor is applied again here.
      return Math.max(0, Math.floor(Number(field.value) || 0));
    }

    document.addEventListener('click', (event) => {
      if (!event.target.closest) return;

      const control = event.target.closest('[data-step], [data-remove]');
      if (!control) return;

      const section = control.closest('[data-cart-section]');
      const line = control.closest('[data-line-key]');
      if (!section || !line) return;

      const key = line.dataset.lineKey;

      if (control.hasAttribute('data-remove')) {
        // The href is a real link to /cart/change that works without this
        // script. With it, the row goes without the page moving.
        event.preventDefault();

        // Any quantity still waiting on this line is moot now.
        window.clearTimeout(timers.get(key));
        timers.delete(key);

        queue = queue.then(() => change(section, key, 0));
        return;
      }

      const field = line.querySelector('[data-quantity-input]');
      if (!field) return;

      // The stepper floors at one: removing a line is what the Remove link is
      // for, and a click that quietly deletes one isn't recoverable.
      const quantity = Math.max(1, quantityOf(field) + Number(control.dataset.step));

      // Written straight into the field so the number moves under the click.
      // The totals follow when the cart replies.
      field.value = quantity;
      line.querySelectorAll('[data-step="-1"]').forEach((button) => {
        button.disabled = quantity <= 1;
      });

      schedule(section, key, quantity);
    });

    // Typed quantities, including the 0 that empties a line — deliberate in a
    // way that clicking `−` one time too many isn't. The note comes through
    // here too: `change` on a textarea fires when it's left, which is exactly
    // when there's something worth saving.
    document.addEventListener('change', (event) => {
      const field = event.target;
      if (!field.matches) return;

      if (field.matches('[data-cart-note]')) {
        const noteSection = field.closest('[data-cart-section]');
        if (!noteSection) return;

        // On the same queue as the quantity writes. Clicking a stepper blurs
        // the note first, so the note is already queued ahead of the change
        // whose reply re-renders the field.
        queue = queue.then(() => saveNote(noteSection, field.value));
        return;
      }

      if (!field.matches('[data-quantity-input]')) return;

      const section = field.closest('[data-cart-section]');
      const line = field.closest('[data-line-key]');
      if (!section || !line) return;

      const quantity = quantityOf(field);
      field.value = quantity;

      schedule(section, line.dataset.lineKey, quantity);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    
  // Drives the banner and the preferences dialog through Shopify's Customer
  // Privacy API, which is what actually records a decision and gates Shopify's
  // own analytics and marketing pixels. Nothing here writes a cookie itself.
  //
  // This isn't progressive enhancement in the usual sense. Without the API
  // there's no consent to record and no banner worth showing, so the markup
  // ships hidden and only this script reveals it — a banner nobody can dismiss
  // would be worse than none at all.
  (() => {
    // Every purpose the API understands. `sale_of_data` is handled apart from
    // the rest: it's only a decision in some regions, and elsewhere the dialog
    // shouldn't record an answer to a question it never asked.
    const BASE_KEYS = ['analytics', 'marketing', 'preferences'];
    const SALE_KEY = 'sale_of_data';

    // The API arrives with `content_for_header`, which has run long before this
    // bundle does. The wait is for the theme editor, which re-renders sections
    // without reloading the page.
    const POLL_INTERVAL = 100;
    const POLL_LIMIT = 50;

    // Long enough for the panel to finish sliding out before it leaves the
    // layout. Matches the transition in the stylesheet above.
    const HIDE_DELAY = 200;

    let apiPromise = null;
    let hideTimer = null;

    function loadApi() {
      if (apiPromise) return apiPromise;

      apiPromise = new Promise((resolve, reject) => {
        let attempts = 0;

        function attempt() {
          const shopify = window.Shopify;

          if (shopify && shopify.customerPrivacy) {
            resolve(shopify.customerPrivacy);
            return;
          }

          if (shopify && typeof shopify.loadFeatures === 'function') {
            shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              if (error || !window.Shopify.customerPrivacy) {
                reject(error || new Error('Customer Privacy API unavailable'));
                return;
              }

              resolve(window.Shopify.customerPrivacy);
            });
            return;
          }

          attempts += 1;

          if (attempts > POLL_LIMIT) {
            reject(new Error('Shopify.loadFeatures never appeared'));
            return;
          }

          setTimeout(attempt, POLL_INTERVAL);
        }

        attempt();
      });

      return apiPromise;
    }

    function banner() {
      return document.querySelector('[data-cookie-banner]');
    }

    function dialog() {
      return document.querySelector('[data-cookie-dialog]');
    }

    // Which purposes this shopper is actually being asked about. Anything left
    // out is left untouched by `setTrackingConsent`, which is the point.
    function activeKeys(api) {
      if (api.saleOfDataRegion && api.saleOfDataRegion()) {
        return BASE_KEYS.concat(SALE_KEY);
      }

      return BASE_KEYS;
    }

    function showBanner() {
      const element = banner();
      if (!element) return;

      clearTimeout(hideTimer);
      element.hidden = false;

      // A frame between unhiding and marking it shown is what gives the
      // transition something to run from.
      requestAnimationFrame(() => {
        element.dataset.cookieShown = 'true';
      });
    }

    function hideBanner() {
      const element = banner();
      if (!element) return;

      delete element.dataset.cookieShown;

      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        // Guard against a re-open landing inside the delay — the editor can
        // show the banner again while it's still sliding out.
        if (element.dataset.cookieShown) return;
        element.hidden = true;
      }, HIDE_DELAY);
    }

    function record(api, consent) {
      api.setTrackingConsent(consent, () => {});
      hideBanner();
    }

    function acceptAll(api) {
      const consent = {};
      activeKeys(api).forEach((key) => {
        consent[key] = true;
      });

      record(api, consent);
    }

    function declineAll(api) {
      const consent = {};
      activeKeys(api).forEach((key) => {
        consent[key] = false;
      });

      record(api, consent);
    }

    // Fills the dialog from what the shopper has already chosen, so re-opening
    // it shows their current answer rather than a blank slate.
    function openDialog(api) {
      const element = dialog();
      if (!element) return;

      const keys = activeKeys(api);
      const consent = api.currentVisitorConsent();

      const saleRow = element.querySelector('[data-cookie-row="' + SALE_KEY + '"]');
      if (saleRow) saleRow.hidden = keys.indexOf(SALE_KEY) === -1;

      keys.forEach((key) => {
        const input = element.querySelector('[data-cookie-option="' + key + '"]');
        if (!input) return;
        input.checked = consent[key] === 'yes';
      });

      element.showModal();
    }

    function saveDialog(api) {
      const element = dialog();
      if (!element) return;

      const consent = {};

      activeKeys(api).forEach((key) => {
        const input = element.querySelector('[data-cookie-option="' + key + '"]');
        if (!input) return;
        consent[key] = input.checked;
      });

      record(api, consent);
    }

    // One delegated listener for every control, so nothing has to be re-bound
    // when the theme editor swaps the section's markup out.
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const control = target.closest(
        '[data-cookie-accept], [data-cookie-decline], [data-cookie-customize], [data-cookie-preferences]'
      );
      if (!control) return;

      event.preventDefault();

      loadApi()
        .then((api) => {
          if (control.hasAttribute('data-cookie-accept')) {
            acceptAll(api);
          } else if (control.hasAttribute('data-cookie-decline')) {
            declineAll(api);
          } else {
            openDialog(api);
          }
        })
        .catch(() => {});
    });

    // Escape and Cancel both land here with an empty or "cancel" return value,
    // which leaves the existing consent alone.
    document.addEventListener('close', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.hasAttribute('data-cookie-dialog')) return;
      if (target.returnValue !== 'save') return;

      loadApi()
        .then((api) => saveDialog(api))
        .catch(() => {});
    }, true);

    function init() {
      loadApi()
        .then((api) => {
          // The reopen link lives in the footer and stays hidden until there's
          // an API behind it to answer.
          document.querySelectorAll('[data-cookie-preferences]').forEach((element) => {
            element.hidden = false;
          });

          if (api.shouldShowBanner()) showBanner();
        })
        .catch(() => {});
    }

    init();

    // The theme editor re-renders the section on every settings change, and
    // needs the banner visible while the merchant is styling it — its own
    // region rarely being one where it would otherwise appear.
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', (event) => {
      if (!event.target.querySelector('[data-cookie-banner]')) return;
      showBanner();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (!event.target.querySelector('[data-cookie-banner]')) return;

      loadApi()
        .then((api) => {
          if (!api.shouldShowBanner()) hideBanner();
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  // Two jobs, both upgrades on markup that already works: fill the province
  // select from whichever country is chosen, and confirm a delete before it
  // happens. With the script absent the country still posts, the province falls
  // back to the plain text input in the `<noscript>`, and delete goes straight
  // through — which is the behaviour Shopify has always had.
  (() => {
    function fillProvinces(countrySelect) {
      const scope = countrySelect.closest('[data-address-form]');
      const wrap = scope && scope.querySelector('[data-province-wrap]');
      const select = scope && scope.querySelector('[data-province]');
      if (!wrap || !select) return;

      const option = countrySelect.options[countrySelect.selectedIndex];
      let provinces = [];

      try {
        provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
      } catch (error) {
        provinces = [];
      }

      // A country with no provinces has no question to ask, so the field goes
      // rather than sitting there empty.
      wrap.hidden = provinces.length === 0;
      if (provinces.length === 0) {
        select.innerHTML = '';
        return;
      }

      const chosen = select.dataset.selected || select.value;
      select.innerHTML = provinces
        .map(([value, label]) => `<option value="${value}">${label}</option>`)
        .join('');
      if (chosen) select.value = chosen;
    }

    function start(root) {
      root.querySelectorAll('[data-address-country]').forEach((select) => {
        fillProvinces(select);
      });
    }

    document.addEventListener('change', (event) => {
      if (event.target.matches && event.target.matches('[data-address-country]')) {
        // A country the shopper picked themselves shouldn't keep the province
        // saved against the old one.
        const scope = event.target.closest('[data-address-form]');
        const province = scope && scope.querySelector('[data-province]');
        if (province) delete province.dataset.selected;

        fillProvinces(event.target);
      }
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-confirm]');
      if (!button) return;
      if (!window.confirm(button.dataset.confirm)) event.preventDefault();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(document));
    } else {
      start(document);
    }

    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Delegated so it works no matter when the bundle runs, and keeps working
  // after the theme editor re-renders the section.
  document.addEventListener('change', (event) => {
    if (!event.target.matches('.footer-country-select')) return;
    event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Keeps the catalog row's edge fades in sync with its scroll position, and
  // brings the collection you're currently browsing into view on load.
  (() => {
    function setupCatalog(nav) {
      if (nav.dataset.catalogReady) return;
      nav.dataset.catalogReady = 'true';

      const wrap = nav.closest('[data-catalog-wrap]');
      const arrows = wrap ? Array.from(wrap.querySelectorAll('[data-catalog-nav]')) : [];

      function update() {
        const max = nav.scrollWidth - nav.clientWidth;

        // Nothing to scroll: drop the attribute so no mask is applied at all,
        // and put the arrows back out of reach.
        if (max <= 1) {
          delete nav.dataset.overflow;
          arrows.forEach((arrow) => {
            arrow.hidden = true;
          });
          return;
        }

        // 1px of slack absorbs sub-pixel scroll positions on zoomed displays.
        const atStart = nav.scrollLeft <= 1;
        const atEnd = nav.scrollLeft >= max - 1;

        if (atStart) {
          nav.dataset.overflow = 'end';
        } else if (atEnd) {
          nav.dataset.overflow = 'start';
        } else {
          nav.dataset.overflow = 'both';
        }

        // Which viewports these are allowed to appear at is the stylesheet's
        // call, not this script's — `hidden` only says there's somewhere to go.
        arrows.forEach((arrow) => {
          arrow.hidden = false;
          arrow.disabled = Number(arrow.dataset.catalogNav) > 0 ? atEnd : atStart;
        });
      }

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          nav.scrollBy({
            left: nav.clientWidth * Number(arrow.dataset.catalogNav),
            behavior: reduced ? 'auto' : 'smooth',
          });
        });
      });

      nav.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Re-measure once webfonts land, since they change the row's width.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(update);
      }

      // Centre the active collection. Adjusting scrollLeft by the measured delta
      // keeps the scroll local to this row — scrollIntoView would also pan any
      // scrollable ancestor, which on a phone means jumping the whole page.
      const current = nav.querySelector('[aria-current="page"]');

      if (current) {
        const navBox = nav.getBoundingClientRect();
        const itemBox = current.getBoundingClientRect();
        nav.scrollLeft += itemBox.left - navBox.left - (navBox.width - itemBox.width) / 2;
      }

      update();
    }

    function init() {
      document.querySelectorAll('.header__catalog').forEach(setupCatalog);
    }

    init();

    // The theme editor re-renders the section on every settings change.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Keeps the price, the button total and the gallery in step with the option
  // selects, and drives the quantity stepper.
  //
  // Everything here is an upgrade on markup that already works: the form is an
  // ordinary POST to /cart/add, and with the script absent the no-script variant
  // select in the markup takes over the choosing.
  (() => {
    const TOTAL_PLACEHOLDER = '[[total]]';

    // Only reached if the shop has no money format at all. Written in two
    // pieces because a pair of opening braces in this file would be read as the
    // start of a Liquid expression.
    const DEFAULT_MONEY_FORMAT = '${' + '{amount}}';

    // Mirrors the `money` filter by substituting into the shop's own format
    // string, so a figure written by this script and one written by Liquid can't
    // disagree — every other character in the format is passed through untouched.
    function formatMoney(cents, format) {
      const amount = Number(cents) || 0;

      function withDelimiters(precision, thousands, decimal) {
        const fixed = (amount / 100).toFixed(precision);
        const parts = fixed.split('.');
        const whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, `$1${thousands}`);
        return parts[1] ? whole + decimal + parts[1] : whole;
      }

      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => {
        switch (name) {
          case 'amount':
            return withDelimiters(2, ',', '.');
          case 'amount_no_decimals':
            return withDelimiters(0, ',', '.');
          case 'amount_with_comma_separator':
            return withDelimiters(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return withDelimiters(0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return withDelimiters(2, "'", '.');
          case 'amount_with_space_separator':
            return withDelimiters(2, ' ', ',');
          case 'amount_no_decimals_with_space_separator':
            return withDelimiters(0, ' ', ',');
          default:
            return match;
        }
      });
    }

    function initSection(root) {
      const form = root.querySelector('.product__form');
      const data = root.querySelector('[data-variant-data]');
      if (!form || !data) return;

      let variants;
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(variants) || variants.length === 0) return;

      // Some shops set a money format that wraps the figure in markup. It's
      // written as text here, so any tags are dropped rather than shown.
      const moneyFormat = (root.dataset.moneyFormat || DEFAULT_MONEY_FORMAT).replace(/<[^>]*>/g, '');

      const selects = Array.from(root.querySelectorAll('[data-option-select]'));
      const idField = form.querySelector('[data-variant-id]');
      const quantityField = form.querySelector('[data-quantity-input]');
      const submit = form.querySelector('[data-submit]');
      const quantityGroup = form.querySelector('[data-quantity-group]');
      const priceField = root.querySelector('[data-price]');
      const compare = root.querySelector('[data-compare]');
      const compareValue = root.querySelector('[data-compare-value]');
      const availability = root.querySelector('[data-availability]');
      const viewer = root.querySelector('[data-viewer]');
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
      const thumbTrack = root.querySelector('[data-thumbs-track]');
      const thumbNav = Array.from(root.querySelectorAll('[data-thumb-nav]'));

      let current = variants.find((variant) => String(variant.id) === idField?.value) || variants[0];

      function quantity() {
        // `min="1"` stops the spinner going below one, but the field can still
        // be cleared or typed into, so the floor is applied again here.
        return Math.max(1, Math.floor(Number(quantityField?.value) || 1));
      }

      function matchVariant() {
        if (selects.length === 0) return current;

        const chosen = selects.map((select) => select.value);
        return variants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options.length === chosen.length &&
            variant.options.every((value, index) => value === chosen[index])
        );
      }

      function reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // Only meaningful once the strip is the two-row scrolling kind; a
      // thumbnail already on screen is left where it is so picking through the
      // strip doesn't shuffle it under the cursor.
      function revealThumb(thumb) {
        if (!thumbTrack) return;

        const slack = thumbTrack.scrollWidth - thumbTrack.clientWidth;
        if (slack <= 1) return;

        const start = thumb.offsetLeft;
        const end = start + thumb.offsetWidth;
        if (start >= thumbTrack.scrollLeft && end <= thumbTrack.scrollLeft + thumbTrack.clientWidth) {
          return;
        }

        const centred = start - (thumbTrack.clientWidth - thumb.offsetWidth) / 2;
        thumbTrack.scrollTo({
          left: Math.max(0, Math.min(centred, slack)),
          behavior: reducedMotion() ? 'auto' : 'smooth',
        });
      }

      // The buttons ship hidden, so this is also what reveals them — and it
      // re-runs whenever the track is resized, where a narrower gallery fits
      // fewer columns and can start overflowing.
      function renderThumbNav() {
        if (!thumbTrack || thumbNav.length === 0) return;

        const slack = thumbTrack.scrollWidth - thumbTrack.clientWidth;

        thumbNav.forEach((button) => {
          const forward = Number(button.dataset.thumbNav) > 0;
          button.hidden = slack <= 1;
          button.disabled = forward
            ? thumbTrack.scrollLeft >= slack - 1
            : thumbTrack.scrollLeft <= 1;
        });
      }

      function setActiveThumb(mediaId) {
        thumbs.forEach((thumb) => {
          const isActive = thumb.dataset.mediaId === String(mediaId);
          thumb.classList.toggle('product__thumb--active', isActive);
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            revealThumb(thumb);
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      function showMedia(mediaId) {
        if (!viewer) return;

        const slide = slides.find((item) => item.dataset.mediaId === String(mediaId));
        if (!slide) return;

        viewer.scrollTo({
          left: slide.offsetLeft - viewer.offsetLeft,
          behavior: reducedMotion() ? 'auto' : 'smooth',
        });
      }

      function render() {
        const total = current ? current.price * quantity() : 0;
        const buyable = Boolean(current && current.available);

        // There's no quantity to pick for something that can't be bought, so
        // the stepper goes with the submit button.
        if (quantityGroup) {
          quantityGroup.classList.toggle('product__quantity--disabled', !buyable);
          quantityGroup.querySelectorAll('button, input').forEach((control) => {
            control.disabled = !buyable;
          });
        }

        if (submit) {
          if (!current) {
            submit.disabled = true;
            submit.textContent = submit.dataset.unavailableLabel;
          } else if (!current.available) {
            submit.disabled = true;
            submit.textContent = submit.dataset.soldOutLabel;
          } else {
            submit.disabled = false;
            submit.textContent = submit.dataset.addLabel.replace(
              TOTAL_PLACEHOLDER,
              formatMoney(total, moneyFormat)
            );
          }
        }

        if (availability) {
          if (!current) {
            availability.textContent = availability.dataset.unavailableLabel;
          } else if (current.available) {
            availability.textContent = availability.dataset.inStockLabel;
          } else {
            availability.textContent = availability.dataset.soldOutLabel;
          }
        }

        if (!current) return;

        if (idField) idField.value = current.id;
        if (priceField) priceField.textContent = formatMoney(current.price, moneyFormat);

        if (compare) {
          const discounted = current.compare_at_price > current.price;
          compare.hidden = !discounted;
          if (discounted && compareValue) {
            compareValue.textContent = formatMoney(current.compare_at_price, moneyFormat);
          }
        }
      }

      selects.forEach((select) => {
        select.addEventListener('change', () => {
          current = matchVariant();
          render();

          if (current) {
            // Keeps a shared or reloaded URL on the variant being looked at.
            const url = new URL(window.location.href);
            url.searchParams.set('variant', current.id);
            window.history.replaceState({}, '', url);

            const mediaId = current.featured_media && current.featured_media.id;
            if (mediaId) showMedia(mediaId);
          }
        });
      });

      form.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantityField) return;
          quantityField.value = Math.max(1, quantity() + Number(button.dataset.quantityStep));
          render();
        });
      });

      quantityField?.addEventListener('input', render);

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          // The href is a real link to the slide, which is what makes the
          // thumbnails work without this script. With it, the track scrolls on
          // its own rather than the browser jumping the whole page to it.
          event.preventDefault();
          showMedia(thumb.dataset.mediaId);
          setActiveThumb(thumb.dataset.mediaId);
        });
      });

      thumbNav.forEach((button) => {
        button.addEventListener('click', () => {
          if (!thumbTrack) return;

          // A page is whatever is on screen, so this follows `--thumb-cols`
          // across breakpoints without the script having to know the number.
          thumbTrack.scrollBy({
            left: thumbTrack.clientWidth * Number(button.dataset.thumbNav),
            behavior: reducedMotion() ? 'auto' : 'smooth',
          });
        });
      });

      if (thumbTrack && thumbNav.length > 0) {
        thumbTrack.addEventListener('scroll', renderThumbNav, { passive: true });

        // Watching the track rather than the window: the observer goes away
        // with the markup, which matters in the theme editor where a setting
        // change re-runs this whole function against replaced elements.
        if ('ResizeObserver' in window) {
          new ResizeObserver(renderThumbNav).observe(thumbTrack);
        }

        renderThumbNav();
      }

      // Which slide is in view is the source of truth for the active thumbnail,
      // so swiping the gallery keeps the strip below it in step too.
      if (viewer && slides.length > 1 && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) setActiveThumb(entry.target.dataset.mediaId);
            });
          },
          { root: viewer, threshold: 0.6 }
        );

        slides.forEach((slide) => observer.observe(slide));
      }

      // Firefox restores the selects and the quantity field on a soft reload,
      // so the first paint can already be out of step with the markup.
      render();
    }

    function start() {
      document.querySelectorAll('[data-product-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    // The theme editor swaps a section's markup wholesale when a setting
    // changes, which would otherwise leave the new markup unbound.
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-product-section]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  // Fetches the section a second time from the recommendations endpoint and
  // moves the markup across. Nothing is shown until it lands, so a failed or
  // empty response simply leaves the page as it was.
  (() => {
    async function load(container) {
      const url = container.dataset.url;
      if (!url) return;

      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fetched = markup.querySelector('[data-recommendations]');
        if (!fetched) return;
        if (fetched.innerHTML.trim() === '') return;

        container.innerHTML = fetched.innerHTML;
      } catch (error) {
        // Nothing to show and nothing to say — the row is an extra, not the page.
      }
    }

    // The row sits below the fold, so the request waits until it's near enough
    // to matter and doesn't compete with the product's own images.
    function watch(scope) {
      const containers = scope.querySelectorAll('[data-recommendations][data-url]');

      if (!('IntersectionObserver' in window)) {
        containers.forEach(load);
        return;
      }

      const observer = new IntersectionObserver(
        (entries, self) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            self.unobserve(entry.target);
            load(entry.target);
          });
        },
        { rootMargin: '400px' }
      );

      containers.forEach((container) => observer.observe(container));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => watch(document));
    } else {
      watch(document);
    }

    // The theme editor swaps a section's markup wholesale when a setting
    // changes, which empties this row again.
    document.addEventListener('shopify:section:load', (event) => watch(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Two jobs, both of them upgrades on a form that already works: submit the
  // results when the sort order changes, and fold the category the shopper is
  // in back into `q` so searching again keeps it.
  //
  // The category has to travel inside `q` because storefront search has no
  // filter parameter — see the note at the top of this section. With the script
  // absent, a new search simply drops back to all products.
  (() => {
    function initSection(root) {
      const form = root.querySelector('[data-search-form]');
      if (!form) return;

      const field = form.querySelector('[data-search-input]');
      const sort = form.querySelector('[data-sort]');

      // `requestSubmit` rather than `submit`: it fires the submit event, which
      // is what folds the category back in below.
      if (sort) sort.addEventListener('change', () => form.requestSubmit());

      form.addEventListener('submit', (event) => {
        const scope = root.dataset.scope;
        if (!scope || !field) return;

        // Built by hand rather than by letting the form serialise itself, so
        // the visible field never has to hold the scoped query — the shopper
        // would otherwise watch `product_type:"…"` appear in the box on submit.
        event.preventDefault();

        const params = new URLSearchParams(new FormData(form));
        const terms = field.value.trim();
        params.set('q', terms ? `${terms} ${scope}` : scope);

        const url = new URL(form.getAttribute('action'), window.location.origin);
        url.search = params.toString();
        window.location.assign(url);
      });
    }

    function start() {
      document.querySelectorAll('[data-search-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    // The theme editor swaps a section's markup wholesale when a setting
    // changes, which would otherwise leave the new markup unbound.
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-search-section]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
